// map popup of a stored river section: own protection height and a value for the whole river (same name)
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
const fmt = (v) => (v == null ? '' : String(v).replace('.', ','));
const num = (v) => { const x = String(v).trim().replace(',', '.'); return x === '' || !Number.isFinite(+x) ? null : Math.max(0, +x); };

export function riverPopup(t, r, gen, close) {
  const el = document.createElement('div'), eff = r.dyke ?? r.nameDyke ?? gen;
  el.className = 'riv-pop'; el.dataset.testid = 'riv-pop';
  el.innerHTML = `<b>${esc(r.name)}</b><small>${esc(t.flPopCur)}: ${fmt(eff)} m</small>
    <label>${esc(t.flPopSec)}<input data-testid="riv-dyke-sec" inputmode="decimal" placeholder="–" value="${fmt(r.dyke)}"></label>
    <label>${esc(t.flPopName.replace('{n}', r.name))}<input data-testid="riv-dyke-name" inputmode="decimal" placeholder="–" value="${fmt(r.nameDyke)}"></label>
    <small class="muted">${esc(t.flPopHint)}</small><button type="button" class="btn btn-sm btn-dark" data-testid="riv-dyke-save">${esc(t.flPopSave)}</button>`;
  el.querySelector('button').onclick = () => {
    const sec = num(el.querySelector('[data-testid=riv-dyke-sec]').value), nm = num(el.querySelector('[data-testid=riv-dyke-name]').value);
    window.dispatchEvent(new CustomEvent('giss-river-dyke', { detail: { i: r.i, name: r.name, p0: r.pts[0], sec, nm } }));
    close();
  };
  return el;
}
